import { useSetLocaleToCacheParams } from "./i18n.mjs";
import { useFetchCategoryBySlug } from "./categories.mjs";
import { useCachedSsrRef } from "./serverCache.mjs";
import { flatten } from "lodash-es";
export var SlugResolver = /* @__PURE__ */ ((SlugResolver2) => {
  SlugResolver2["CATEGORY"] = "category";
  SlugResolver2["PRODUCT"] = "product";
  return SlugResolver2;
})(SlugResolver || {});
export class CategoryProductSlug {
  type;
  payload;
  constructor(_type, _payload) {
    this.type = _type;
    this.payload = _payload;
  }
  toJson() {
    return {
      type: this.type,
      payload: this.payload
    };
  }
}
export async function useResolveSlugParameter(slug, _useFetchProductBySlug) {
  const { cacheParam } = useSetLocaleToCacheParams();
  const cachedCategories = useCachedSsrRef(cacheParam("categories"), []);
  if (cachedCategories.value?.length) {
    const category2 = flatten(cachedCategories.value).find(
      (category3) => category3?.url_key === slug
    );
    if (category2?.id)
      return new CategoryProductSlug("category" /* CATEGORY */, category2).toJson();
  }
  const product = await _useFetchProductBySlug(slug);
  if (product) {
    return new CategoryProductSlug(
      "product" /* PRODUCT */,
      product
    ).toJson();
  }
  const category = await useFetchCategoryBySlug(slug);
  if (category) {
    return new CategoryProductSlug("category" /* CATEGORY */, category).toJson();
  }
  return null;
}
